var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38854 3.41302C6.38854 4.78027 5.28018 5.88854 3.91302 5.88854C2.54586 5.88854 1.4375 4.78018 1.4375 3.41302C1.4375 2.04586 2.54586 0.9375 3.91302 0.9375C5.28018 0.9375 6.38854 2.04586 6.38854 3.41302Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44275 7.89582C7.18544 7.40953 6.7031 7.11914 6.153 7.11914H1.676C1.12618 7.11914 0.644442 7.40953 0.386858 7.89554C0.129273 8.38216 0.160256 8.9441 0.484696 9.42164C0.810357 9.90067 1.29935 10.2284 1.86191 10.3442C2.53288 10.482 3.22365 10.5518 3.91477 10.5518C4.60589 10.5518 5.29658 10.482 5.96764 10.3441C6.52986 10.2283 7.01926 9.90033 7.34579 9.42008L7.36036 9.39879C7.66953 8.94376 7.70054 8.38209 7.44295 7.89581L7.44275 7.89582Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardUser);
export default __webpack_public_path__ + "static/media/cardUser.e3ec4e393cb6d6a95da9f938970358bc.svg";
export { ForwardRef as ReactComponent };